<template lang="pug">
modal(ref="modalShelfLabel" id="modalShelfLabel" )
    template(slot="title") Generate Shelf Label

    template(slot="body")
        .row
            .col-lg-12.text-center
                | Please Select Planogram, Dimension, Sequence & Facing

        .row.text-center.m-t-4
            .col-lg-6
                .md-form-group
                    label Select Planogram
                    select(
                        class="form-control c-select"
                        v-model="plan"
                        :disabled="onLoading('fetch-planogram-list')"
                        @change="handlePlanogramSelect"
                    )
                        option(:value="null") Select option
                        option(
                            v-for="data in planogramList"
                            :value="data.id"
                            :key="data.id")
                            | {{ data.name }}

            .col-lg-6
                .md-form-group
                    label Select Dimension
                    select(
                        class="form-control c-select"
                        v-model="dimension"
                        :disabled="isPlanogramSelectDisabled"
                        @change="onDimensionSelectChange"
                    )
                        option(:value="null") Select option
                        optgroup(v-for="(group, name) in groupDimensionList" :label="name")
                            option(
                                v-for="data in group"
                                :value="data.id"
                                :key="data.id")
                                | {{ data.name }}

        .row.text-center.m-t-4
            .col-lg-6
                .md-form-group
                    label Select Sequence
                    select(
                        class="form-control c-select"
                        v-model="sequence"
                        :disabled="isPlanogramSelectDisabled"

                    )
                        option(:value="null") Select option
                        option(
                            v-for="data in sequenceList"
                            :value="data.sequence"
                            :key="data.product_id")
                            | {{ data.sequence }}
            
            .col-lg-6
                div(v-if="this.dimension === 4")
                    .md-form-group
                        label Select Margin Small
                        select(class="form-control c-select" v-model="selectedSmall" @change="toggleTextField" :disabled="isMarginDisabled")
                            option(value="" disabled) Please Select
                            option(value="option1" selected) W: 3cm H: 1.8cm
                            option(value="option2") W: 2.9cm H: 1.8cm
                            option(value="option3") W: 2.8cm H: 1.8cm
                            option(value="option4") W: 2.7cm H: 1.8cm
                            option(value="others") Custom Values
         
                        label(class="m-t" v-if="showSmallTextField === true") Left
                            input(v-if="showSmallTextField === true" v-model.number="leftMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
                            label(class="text-warning" v-if="showErrorMessageExceedMargin === true") Exceeds maximum recommended left margin of 3cm
                        label(class="m-t" v-if="showSmallTextField === true") Top
                            input(v-if="showSmallTextField === true" v-model.number="topMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
            
                div(v-if="this.dimension === 5")
                    .md-form-group
                        label Select Margin Standard
                        select(class="form-control c-select" v-model="selectedStandard" @change="toggleTextField" :disabled="isMarginDisabled")
                            option(value="" disabled) Please Select
                            option(value="option1" selected) W: 3.1cm H: 1.8cm
                            option(value="option2") W: 3 cm H: 1.8cm
                            option(value="option3") W: 2.9 cm H: 1.8cm
                            option(value="option4") W: 2.8 cm H: 1.8cm 
                            option(value="others") Custom Values
         
                        label(class="m-t" v-if="showStandardTextField === true") Left
                            input(v-if="showStandardTextField === true" v-model.number="leftMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
                            label(class="text-warning" v-if="showErrorMessageExceedMargin === true") Exceeds maximum recommended left margin of 3.1cm
                        label(class="m-t" v-if="showStandardTextField === true") Top
                            input(v-if="showStandardTextField === true" v-model.number="topMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )       
                       
    template(slot="footer")
        button.btn.btn-fw.primary(
            @click="generate",
            :disabled="(!dimension || !plan || !sequence) && !(selectedSmall || selectedStandard)"
        )
            v-loading(loader="generate-planogram") Generate

</template>

<script>
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';
import download from './download-planogram';
export default {
    mixins: [download],

    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            plan: null,
            dimension: null,
            sequence: null,
            facings: null,
            margins: null,
            product: null,
            selectedSmall: null,
            selectedStandard: null,
            selectedOption: null,
            leftMargin: null,
            topMargin: null,
            showErrorMessageExceedMargin: false,
            showSmallTextField: false,
            showStandardTextField: false,
        };
    },

    computed: {
        ...mapGetters({
            planogramList: 'planogram/planogramNameList',
            sequenceList: 'planogram/sequenceList',
            facingList: 'planogram/facingList',
            dimensionList: 'planogram/dimensionList',
            groupDimensionList: 'planogram/groupDimensionList',
        }),

        isPlanogramSelectDisabled() {
            return !this.plan;
        },
        isSequenceSelectDisabled() {
            return !this.sequence;
        },

        isMarginDisabled() {
            return this.dimension !== 4 && this.dimension !== 5;
        },
    },

    mounted() {
        this.$on('show', e => {
            this.clearInputPlanogramData();
            this.product = e;
            this.$store.dispatch('planogram/getList', {
                product_id: this.product.id,
            });
            this.$refs.modalShelfLabel.$emit('show');
        });

        if (Auth.hasPermissionTo('franchise_generate_planogram')) {
            this.$store.dispatch('planogram/getDimensionList');
        }
    },

    methods: {
        handlePlanogramSelect() {
            if (this.plan) {
                this.$store.dispatch('planogram/getProductSequence', {
                    product_id: this.product.id,
                    planogram_id: this.plan,
                });
            }
        },
        async generate() {
            // convert cm to mm
            const left_margin = this.leftMargin * 10;
            const top_margin = this.topMargin * 10;

            let params = {
                planogram_id: [this.plan],
                product_sequence: [this.sequence],
                dimension: this.dimension,
                leftMargin: left_margin,
                topMargin: top_margin,
                selectedOption: this.selectedOption,
                product_id: [this.product.id],
                pricebook_id: this.id,
            };
            await this.generatePlanogram(params, true);
            this.clearInputPlanogramData();
        },
        hideModal() {
            $('#modalShelfLabel').modal('hide');
        },
        clearInputPlanogramData() {
            this.dimension = null;
            this.plan = null;
            this.sequence = null;
            this.selectedSmall = null;
            this.selectedStandard = null;
            this.selectedOption = null;
            this.leftMargin = '';
            this.topMargin = '';
        },

        setMarginSmallForFirstOption() {
            this.leftMargin = 3;
            this.topMargin = 1.8;
        },

        setMarginSmallForSecondOption() {
            this.leftMargin = 2.9;
            this.topMargin = 1.8;
        },

        setMarginSmallForThirdOption() {
            this.leftMargin = 2.8;
            this.topMargin = 1.8;
        },

        setMarginSmallForFourthOption() {
            this.leftMargin = 2.7;
            this.topMargin = 1.8;
        },

        setMarginStandardForFirstOption() {
            this.leftMargin = 3.1;
            this.topMargin = 1.8;
        },

        setMarginStandardForSecondOption() {
            this.leftMargin = 3;
            this.topMargin = 1.8;
        },

        setMarginStandardForThirdOption() {
            this.leftMargin = 2.9;
            this.topMargin = 1.8;
        },

        setMarginStandardForFourthOption() {
            this.leftMargin = 2.8;
            this.topMargin = 1.8;
        },

        checkSmallOrStandard() {
            if (this.dimension === 5) {
                this.showStandardTextField = this.selectedStandard === 'others';
            }

            if (this.dimension === 4) {
                this.showSmallTextField = this.selectedSmall === 'others';
            }
        },

        clearSmallorStandardTextfield() {
            this.showSmallTextField == false;
            this.showStandardTextField == false;
        },

        toggleTextField() {
            this.checkSmallOrStandard();

            // handle for small
            if (this.selectedSmall === 'option1') {
                this.setMarginSmallForFirstOption();
            }

            if (this.selectedSmall === 'option2') {
                this.setMarginSmallForSecondOption();
            }

            if (this.selectedSmall === 'option3') {
                this.setMarginSmallForThirdOption();
            }

            if (this.selectedSmall === 'option4') {
                this.setMarginSmallForFourthOption();
            }

            // handle for standard
            if (this.selectedStandard == 'option1') {
                this.setMarginStandardForFirstOption();
            }

            if (this.selectedStandard == 'option2') {
                this.setMarginStandardForSecondOption();
            }

            if (this.selectedStandard == 'option3') {
                this.setMarginStandardForThirdOption();
            }

            if (this.selectedStandard == 'option4') {
                this.setMarginStandardForFourthOption();
            }

            this.onMarginSelectionOptionChange();
        },

        onDimensionSelectChange() {
            this.selectedOption = null;
            this.selectedSmall = null;
            this.selectedStandard = null;
        },
        onMarginSelectionOptionChange() {
            if (this.dimension === 4) {
                if (this.leftMargin > 3) {
                    // Display or update error message as needed
                    this.showErrorMessageExceedMargin = true;
                } else {
                    this.showErrorMessageExceedMargin = false;
                }
            }

            if (this.dimension === 5) {
                if (this.leftMargin > 3.1) {
                    this.showErrorMessageExceedMargin = true;
                } else {
                    this.showErrorMessageExceedMargin = false;
                }
            }

            if (this.selectedSmall) {
                this.selectedOption = this.selectedSmall;

                this.marginSelectionSmallOptionChange(this.selectedSmall);
            }

            if (this.selectedStandard) {
                this.selectedOption = this.selectedStandard;
                this.marginSelectionStandardOptionChange(this.selectedStandard);
            }
        },

        marginLeftChange(leftMargin) {
            this.leftMargin = leftMargin;
        },

        marginTopChange(topMargin) {
            this.topMargin = topMargin;
        },

        marginSelectionSmallOptionChange(selectedOption) {
            this.selectedSmall = selectedOption;
        },

        marginSelectionStandardOptionChange(selectedOption) {
            this.selectedStandard = selectedOption;
        },

        checkMarginGenerateDisable() {
            if (this.dimension == 4) {
                if (this.selectedSmall) {
                    this.margins = true;
                }
            } else if (this.dimension == 5) {
                if (this.selectedStandard) {
                    this.margins = true;
                }
            } else {
                this.margins = false;
            }

            return this.margins;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/generate-shelf-label.vue